import { TableClass } from '../../../world/spa/libs/classes';

export default {
	worldEventType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'generic',
				it: "Lavoro",
				en: "Work"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'trip',
				it: "Viaggio",
				en: "Trip"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'night',
				it: "Notturno",
				en: "Night"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'vircosDelivery',
				it: "Consegna Vircos",
				en: "Vircos Delivery"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'reminder',
				it: "Promemoria",
				en: "Reminder"
			}
		});
	},
	calendarNotificationCode() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'newInvite',
				it: "Nuovo invito",
				en: "New invite"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'editEvent',
				it: "Evento modificato",
				en: "Event edited"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'attendance',
				it: "Partecipazione",
				en: "Attendance"
			}
		});
	},
	eventPermission() {
		return new TableClass({
			0: {
				typeClass: 0,
				typeClassLiteral: '0',
				it: "Invitato",
				en: "Guest"
			},
			1: {
				typeClass: 1,
				typeClassLiteral: '1',
				it: "Amministratore",
				en: "Admin"
			}
		});
	},
	inviteStatus() {
		return new TableClass({
			0: {
				typeClass: 0,
				typeClassLiteral: 'waiting',
				it: "In attesa",
				en: "Waiting"
			},
			1: {
				typeClass: 1,
				typeClassLiteral: 'willJoin',
				it: "Parteciperà",
				en: "Will join"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'wontJoin',
				it: "Non parteciperà",
				en: "Won't join"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'willMaybeJoin',
				it: "Forse parteciperà",
				en: "Will maybe join"
			}
		});
	},
	eventStatus() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'confirmed',
				it: "Confermato",
				en: "Confirmed"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'provisional',
				it: "Provvisorio",
				en: "Provisional"
			}
		});
	}
}
